var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"bg-secondary",staticStyle:{"width":"60px","max-height":"15px","margin-top":"35px","margin-right":"-28px","margin-left":"-23px"}})}
var staticRenderFns = []

export { render, staticRenderFns }